import type {ButtonDocument} from 'prismicio-types'
import {useEffect, useMemo} from 'react'
import {getDownloadTemplateUrls, isDownloadTemplateHref} from '../utils'

export const useDownloadTemplateLinks = (buttonsData: ButtonDocument[] | undefined, onOpen: VoidFunction) => {
  const downloadTemplateUrls = useMemo(() => getDownloadTemplateUrls(buttonsData), [buttonsData])

  // Open the modal instead of following any link to a download-template button's PDF, wherever it is rendered
  useEffect(() => {
    if (downloadTemplateUrls.size === 0) {
      return undefined
    }

    const handleClick = (event: MouseEvent) => {
      const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null

      if (!(anchor instanceof HTMLAnchorElement) || !isDownloadTemplateHref(anchor.href, downloadTemplateUrls)) {
        return
      }

      // Capture phase runs before React, so Next Link sees defaultPrevented and skips navigation while tracking still fires
      event.preventDefault()
      onOpen()
    }

    document.addEventListener('click', handleClick, true)
    return () => document.removeEventListener('click', handleClick, true)
  }, [downloadTemplateUrls, onOpen])
}
